import {createAction, props} from '@ngrx/store';
import {Location} from '../location.model';

const action = '[Location]';

export const loadLocations = createAction(`${action} - Load locations`);
export const loadLocationsSuccess = createAction(`${action} - Load locations success`, props<{
  locations: Location[],
  status: 'idle' | 'loading' | 'success' | 'error'
}>());
export const loadLocationsError = createAction(`${action} - Load locations error`);

export const loadLocation = createAction(`${action} - Load location`, props<{ locationId: string }>());
export const loadLocationSuccess = createAction(`${action} - Load location success`, props<{ location: Location }>());
export const loadLocationError = createAction(`${action} - Load location error`);

export const createLocation = createAction(`${action} - Create location`, props<{
  location: Partial<Location>,
  collectionItemId?: string,
}>());
export const createLocationSuccess = createAction(`${action} - Create location success`, props<{
  location: Location,
  collectionItemId?: string,
  collectionItemIds?: number[],
}>());
export const createLocationError = createAction(`${action} - Create location error`);

export const editLocation = createAction(`${action} - Edit location`, props<{ location: Partial<Location> }>());
export const editLocationSuccess = createAction(`${action} - Edit location success`, props<{ location: Location }>());
export const editLocationError = createAction(`${action} - Edit location error`);

export const deleteLocation = createAction(`${action} - Delete location`, props<{ locationId: string }>());
export const deleteLocationSuccess = createAction(`${action} - Delete location success`, props<{ status: string }>());
export const deleteLocationError = createAction(`${action} - Delete location error`);

export const assignLocation = createAction(`${action} - Assign location`, props<{
  locationId: string,
  collectionItemId: string,
  quantity?: number,
  assigningToIds?: number[]
}>());
export const assignLocationSuccess = createAction(`${action} - Assign location success`, props<{
  status: string,
  collectionItemId: string,
}>());
export const assignLocationError = createAction(`${action} - Assign location error`, props<{
  error: string
}>());

export const unassignLocation = createAction(`${action} - Unassign location`, props<{ collectionItemId: string }>());

export const unassignLocationError = createAction(`${action} - Unassign location error`);
export const createLocationToAssignANewItem = createAction(`${action} - Create Location to Assign A new Item`, props<{
  collectionItemId: string
}>());

export const confirmUnassignLocation = createAction(`${action} - Confirm unassign location`, props<{
    collectionItemId: string
  }>()
);

export const unassignLocationSuccess = createAction(`${action} - Unassign location success`);

export const resetLoadingStatus = createAction(`${action} - Reset loading status`);
